import { Typography } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import Content from '../components/Layout/Content';
import { Box } from '@mui/system';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import SearchBar from '../components/SearchBar/Search';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  formatDateInMMDDYYYYWithComma,
  getIconFromSubItemsArray,
  getUSFormatPhoneNo,
  handleStatusFilter,
  searchDataByKey,
} from '../shared/helper';
import ApplicationContext from '../context/applicationContext';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import { careTeamArrayConvertor } from '../shared/helper';
import NotFound from '../components/NotFound/NotFoundPage';
import { useLazyQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import {
  careTeamsStatusFilterDatas,
  DEFAULT_NULL_REPLACEMENT,
  NUMBER_OF_ROWS_PER_PAGE,
} from '../shared/constants';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import {
  FETCH_ALL_CARETEAMS_QUERY,
  FETCH_CARETEAM_BY_ID_QUERY,
} from '../services/CareTeamQueries/CareTeamService';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import CareTeamComposnent from '../components/CareTeamComponent/CareTeamComposnent';
import avataricon from '../assests/avataricon.svg';
import {
  CARETEAM,
  CARETEAM_TABLE_HEADING as tableHeading,
  CARETEAM_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import { useLocation } from 'react-router-dom';

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};
export const CareTeam = () => {
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = React.useState([]);
  const [statusFilter, setStatusFilter] = React.useState('all');
  const [filteredData, setFilteredData] = useState([]);
  const [openFlyout, setOpenFlyout] = useState(false);
  const { menuItems } = useContext(ApplicationContext);
  const [detailsData, setDetailsData] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [role, setRole] = useState();
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();

  const [fetchAllCareTeam, fetchAllCareTeamCall] = useLazyQuery(
    FETCH_ALL_CARETEAMS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CARETEAM.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = res.fetchAllCareTeams.careTeamList;
        let convertor = JSON.parse(result);
        let data = careTeamArrayConvertor(convertor);
        setRecordedData(data);
        setFilteredData(data);
        setTotalCount(res.fetchAllCareTeams.count);
      },
    }
  );

  const [fetchCareTeamById, fetchCareTeamByIdCall] = useLazyQuery(
    FETCH_CARETEAM_BY_ID_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(CARETEAM.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        showFlyout(res.fetchCareTeamById);
      },
    }
  );

  useEffect(() => {
    fetchAllCareTeam({
      variables: {
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: 0,
        statusFilter: statusFilter === 'all' ? '' : statusFilter,
        searchFilter: '',
      },
    });
  }, [offset, statusFilter]);

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const closeFlyout = () => {
    setOpenFlyout(false);
  };
  const onSearch = text => {
    setSearchValue(text);
  };

  const handleChangeFilter = () => {
    setOffset(0);
  };
  const statusFilterOptions = {
    options: careTeamsStatusFilterDatas,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  useEffect(() => {
    if (location?.search?.split('=')[1]) {
      const refId = location?.search?.split('=')[1];
      viewDetailsHandler(refId);
    }
  }, []);

  React.useEffect(() => {
    const statusFilteredData = handleStatusFilter(
      statusFilter,
      recordsData,
      careTeamsStatusFilterDatas
    );
    const searchData = searchDataByKey(statusFilteredData, 'name', searchValue);
    setFilteredData(searchData);
  }, [statusFilter, searchValue, recordsData]);

  const showFlyout = result => {
    const dataFormatted = JSON.parse(result.careTeam);
    setModalTitle(dataFormatted?.name || DEFAULT_NULL_REPLACEMENT);
    setRole(
      dataFormatted?.managingOrganization?.[0].display ||
        DEFAULT_NULL_REPLACEMENT
    );
    const modalData = [
      {
        column_name: CARETEAM.MODAL_DATA.STATUS,
        value: dataFormatted?.status || DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CARETEAM.MODAL_DATA.PHONE_NUMBER,
        value:
          getUSFormatPhoneNo(dataFormatted?.telecom?.[0]?.value) ||
          DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CARETEAM.MODAL_DATA.START_DATE,
        value:
          formatDateInMMDDYYYYWithComma(dataFormatted?.period?.start) ||
          DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CARETEAM.MODAL_DATA.END_DATE,
        value:
          formatDateInMMDDYYYYWithComma(dataFormatted.period?.end) ||
          DEFAULT_NULL_REPLACEMENT,
        width: 5,
      },
      {
        column_name: CARETEAM.MODAL_DATA.REASON,
        value:
          dataFormatted?.reasonCode?.[0]?.coding?.[0]?.display ||
          DEFAULT_NULL_REPLACEMENT,
        width: 12,
      },
      {
        column_name: CARETEAM.MODAL_DATA.NOTE,
        value: dataFormatted?.note?.[0]?.text || DEFAULT_NULL_REPLACEMENT,
        width: 12,
      },
    ];

    setDetailsData(modalData);
    setOpenFlyout(true);
  };
  const viewDetailsHandler = id => {
    fetchCareTeamById({
      variables: {
        careTeamId: id,
      },
    });
  };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{CARETEAM.TITLE_TEXT}</Typography>
      <Box sx={{ display: 'flex', position: 'relative', top: 40 }}>
        {/* <SearchBar
          sx={{
            width: '50%',
            minWidth: '250px',
            maxWidth: '500px',
            marginTop: '8px',
          }}
          onSearch={onSearch}
          placeholder={CARETEAM.SEARCH_PLACEHOLDER_TEXT}
        /> */}

        <FilterDropDown {...statusFilterOptions} filterType="Status:" />
      </Box>
      <Box sx={table}>
        {!fetchAllCareTeamCall?.loading && !filteredData?.length ? (
          <NotFound title={CARETEAM.TITLE_TEXT} />
        ) : (
          <>
            <ReusableTable
              tableHeading={tableHeading}
              data={filteredData}
              viewDetailsHandler={viewDetailsHandler}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 18,
              }}>
              {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                <PaginationComponent
                  numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                  count={totalCount}
                  onPageClick={onPageClick}
                  page={offset / 10}
                />
              )}
            </div>
          </>
        )}
      </Box>
      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        data={detailsData}
        img={avataricon}
        category={CARETEAM.TITLE_TEXT}
        title={modalTitle}
        messages={true}
        role={role}>
        <CareTeamComposnent
          icon={
            menuItems
              ? getIconFromSubItemsArray(
                  menuItems?.Care?.subItems,
                  'Care Plans'
                )
              : null
          }></CareTeamComposnent>
      </ServiceFlyout>
      <SimpleBackdrop
        open={fetchAllCareTeamCall.loading || fetchCareTeamByIdCall.loading}
      />
    </Content>
  );
};
